var map = {
	"./company1.png": "1443",
	"./company10.png": "2c23",
	"./company11.png": "03c8",
	"./company12.png": "7426",
	"./company13.png": "32bd",
	"./company14.png": "5041",
	"./company15.png": "7047",
	"./company2.png": "4724",
	"./company3.png": "08e6",
	"./company4.png": "81d0",
	"./company5.png": "8931",
	"./company6.png": "f212",
	"./company7.png": "1948",
	"./company8.png": "524f",
	"./company9.png": "5620"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a65";